import { useEffect } from 'react';

/** Título da aba. Ajuda quem trabalha com 6 abas abertas o dia inteiro. */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} · MGDLead`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
